/**
=========================================================
* HG Pro - v3.1.0
=========================================================

* Product Page: https://hgpro.nyc/product/soft-ui-dashboard-pro-react
* Copyright 2022 HG Pro (https://hgpro.nyc/)

Coded by hgpro.theworkflow.nyc

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const buttonBase = {
  defaultProps: {
    disableRipple: true,
  },
};

export default buttonBase;
